var $ = require("jquery");
var utils = require("../../shared/utils");
require("./loginPage.css");
var create = function(selector) {

	// TODO: show message saying they are already logged in or redirect
	if (utils.isAuthenticated()) {
		var html = `<p>
			You're already logged in. Click
			<a title="Log Out" href="/_layouts/15/NATPAuth/Logout.aspx" target="_self"> here </a>
			to log out.
		</p>`
		$("#login-page-content").html(html);
	}

	var selectors = {
		formContainer: ".login-page-form-container",
		form: ".natp-login-form",
	}
	setTimeout(() => {
		$(selectors.formContainer).html("");
		$(".natp-login-form").appendTo(selectors.formContainer);
		$(".natp-login-form").show();
	}, 1);
};

module.exports = { create: create };



// WEBPACK FOOTER //
// ./src/scripts/components/loginPage/index.js